import React from 'react';
import { FlowTransactionReportBase } from './flowTransactionReportSum';

const FlowTransactionReport = () => (
  <FlowTransactionReportBase
    apiPath="/api/flowTransectionReport/flowTransectionReport"
    reportTitle="Flow Transaction Report"
  />
);

export default FlowTransactionReport;
